module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.efe5d137.png";